import { Link } from 'react-router-dom';
import {
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Twitter,
  Github,
  Instagram,
  ArrowUpRight,
  Send, 
  Target} from
'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import logo from '../assets/jnan-logo.png';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
    { name: 'About Us', path: '/about' },
    { name: 'Our Services', path: '/services' },
    { name: 'Setu AI Product', path: '/product' },
    { name: 'Contact', path: '/contact' }],

    services: [
    { name: 'AI Integration', path: '/services#ai-integration' },
    { name: 'Web Development', path: '/services#web-development' },
    { name: 'App Development', path: '/services#app-development' },
    { name: 'Custom Integrations', path: '/services#custom-integrations' },
    { name: 'Netsuite Integrations', path: '/services#netsuite-integrations' },
    { name: 'Amazon SP-API Integration', path: '/amazon-integration' }
  ],

    resources: [
    /* { name: 'Case Studies', path: '#' },
    { name: 'Documentation', path: '#' },
    { name: 'API Reference', path: '#' }, */
    { name: 'Support', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Amazon Data Protection Policy', path: '/amazon-data-protection-policy' },
    { name: 'Information Security Policy', path: '/information-security-policy' },
    { name: 'Data Classification Policy', path: '/data-classification-policy' },
    { name: 'Incident Response Policy', path: '/incident-response-policy' },
    { name: 'Data Retention Policy', path: '/data-retention-policy' },
    { name: 'Terms & Conditions', path: '/terms-conditions' }
  ]

  };

  const socialLinks = [
  { icon: Linkedin, href: 'https://www.linkedin.com/company/jnanit/', label: 'LinkedIn' , target: '_blank' },
  /* { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Github, href: '#', label: 'GitHub' },
  { icon: Instagram, href: '#', label: 'Instagram' } */
];


  return (
    <footer data-testid="main-footer" className="bg-slate-900 text-white">
      {/* Newsletter Section */}
      {/* <div className="border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <h3 className="text-2xl font-bold font-['Outfit'] mb-2">
                Stay Updated with Our Latest Innovations
              </h3>
              <p className="text-slate-400">
                Get insights on AI, technology trends, and exclusive updates.
              </p>
            </div>
            <div className="flex w-full max-w-md gap-3">
              <Input
                data-testid="newsletter-email-input"
                type="email"
                placeholder="Enter your email"
                className="bg-slate-800 border-slate-700 text-white placeholder:text-slate-500 rounded-full px-5" />

              <Button
                data-testid="newsletter-submit-button"
                className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 rounded-full px-6 whitespace-nowrap">

                <Send className="w-4 h-4 mr-2" />
                Subscribe
              </Button>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              {/* <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-purple-600 flex items-center justify-center">
                <span className="text-white font-bold text-lg font-['Outfit']"></span>
              </div> */}
              <img 
                src={logo} 
                alt="Logo" 
                className="w-24 h-12 object-contain"
              />
            </Link>
            <p className="text-slate-400 mb-6 max-w-sm leading-relaxed">
              Pioneering the future of business through innovative AI solutions, 
              seamless integrations, and cutting-edge technology development.
            </p>
            {/* Contact Info */}
            <div className="space-y-3">
              <a
                href="mailto:info@jnanit.com"
                className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">

                <Mail className="w-5 h-5 text-blue-500" />
                info@jnanit.com
              </a>
              <a
                href="tel:+17473431011"
                className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">

                <Phone className="w-5 h-5 text-blue-500" />
                +1 (747)-343-1011
              </a>
              {/* <div className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span>123 Innovation Street, Tech Valley, CA 94000</span>
              </div> */}
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold font-['Outfit'] text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) =>
              <li key={link.name}>
                  <Link
                  to={link.path}
                  className="text-slate-400 hover:text-white transition-colors flex items-center gap-1 group">

                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-semibold font-['Outfit'] text-white mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) =>
              <li key={link.name}>
                  <Link
                  to={link.path}
                  className="text-slate-400 hover:text-white transition-colors flex items-center gap-1 group">

                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="font-semibold font-['Outfit'] text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) =>
              <li key={link.name}>
                  <Link
                  to={link.path}
                  className="text-slate-400 hover:text-white transition-colors flex items-center gap-1 group">

                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} JnanIT. All rights reserved.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social) =>
              <a
                key={social.label}
                href={social.href}
                data-testid={`social-link-${social.label.toLowerCase()}`}
                aria-label={social.label}
                className="w-10 h-10 rounded-full bg-slate-800 hover:bg-slate-700 flex items-center justify-center transition-colors group">

                  <social.icon className="w-5 h-5 text-slate-400 group-hover:text-white transition-colors" />
                </a>
              )}
            </div>

            {/* <div className="flex items-center gap-6 text-sm text-slate-500">
              <Link to="#" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;
